interface Props {
	title: string;
	path: string;
	lang?: "EN" | "NL";
}

const LABELS = {
	EN: { view: "View", download: "Download" },
	NL: { view: "Bekijk", download: "Download" },
};

export function ViewAndDownload({ title, path, lang = "EN" }: Props) {
	const l = LABELS[lang];
	return (
		<div className="eo-doc">
			<span>{title}</span>
			<span className="eo-doc__actions">
				<a className="eo-doc__action" target="_blank" href={path} rel="noreferrer" aria-label={`${l.view}: ${title}`}>
					{l.view}
				</a>
				<a className="eo-doc__action" download href={path} aria-label={`${l.download}: ${title}`}>
					{l.download}
				</a>
			</span>
		</div>
	);
}
